import React from "react";
const About = () => {
  return (
    <div>
      <h3 className="mb-4 h5">About me 👋</h3>
      <p className="fw-light text-muted">
        I'm Heval (Meaning "Friend" in English).
        <br />
        <br />
        As a <strong className="fw-light">
          Front-End Developer
        </strong>&nbsp;and{" "}
        <strong className="fw-light">User Interface Designer</strong>, I develop
        aesthetic and powerful things.
        <br />
        <br />I love to take part in beautiful projects with the idea of
        ​​making the internet a better place.
      </p>
    </div>
  );
};

export default About;
